import React from 'react'
import Banner from '../Components/Banner'
import CoinsTable from '../Components/CoinsTable'

const Homepage = () => {
  return <> 
    <Banner />
    <CoinsTable />
    <div class="pad"></div>
  </>
  
}

export default Homepage